import { Container } from '@doist/marketist'

import cn from 'classnames'

import css from './container-sidebar.module.css'

type ContainerSidebarChildren = {
    children: React.ReactNode
    sidebarChildren?: React.ReactNode
    className?: string
    tag?: React.ElementType
}

export function ContainerSidebar({ children, className, tag }: ContainerSidebarChildren) {
    return (
        <Container className={cn(css.containerSidebar, className)} tag={tag}>
            {children}
        </Container>
    )
}

type ContainerSidebarMainProps = {
    children: React.ReactNode
    className?: string
}

ContainerSidebar.Main = function ContainerSidebarMain({
    children,
    className,
}: ContainerSidebarMainProps) {
    return <div className={cn(css.main, className)}>{children}</div>
}

type ContainerSidebarAsideProps = {
    children: React.ReactNode
    className?: string
    tag?: React.ElementType
}

ContainerSidebar.Aside = function ContainerSidebarAside({
    children,
    className,
    tag: Tag = 'div',
}: ContainerSidebarAsideProps) {
    return <Tag className={cn(className)}>{children}</Tag>
}
